import { BaseButton, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C4Text } from "../text/CustomText";
import styled from "styled-components";
import { useRef, useState } from "react";
import { format } from "date-fns";
import { useClickOutside } from "../../hooks/useClickOutside";
import CalendarComponent from "../calendar/CalendarComponent";
import { CalendarWrapper } from "../calendar/CalendarMenu";
import { Theme } from "../../Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

function CustomMonthSelectButton({ currentMonth, setCurrentMonth, openedCalendarLeftSide = false }) {
    const [isOpen, setIsOpen] = useState(false);
    const [type, setType] = useState("month");

    const menuRef = useRef(null);
    useClickOutside(menuRef, () => {
        if (isOpen) setIsOpen(false);
    });

    const handleMonthSelect = (date) => {
        setCurrentMonth(date);
        setIsOpen(false);
        setType("month"); // 다음에 열 때 다시 월 선택부터 시작
    };

    const handleCaptionClick = () => {
        setType((prev) => (prev === "month" ? "year" : "month"));
    };

    return (
        <MenuContainer ref={menuRef}>
            <BaseButton
                padding={"9px 14px"}
                border={`1px solid ${Theme.color.gray250}`}
                borderRadius={"8px"}
                backgroundColor={Theme.color.white}
                onClick={() => setIsOpen((prev) => !prev)}
                hoverBackgroundColor={Theme.color.neutral100}
            >
                <Row alignItem={"center"} cursor={"pointer"}>
                    <CustomIcon iconName={"date"} width={"13.5px"} height={"12px"} />
                    <SizedBox width={"8px"} />
                    <C4Text fontColor={Theme.color.zinc850}>{format(currentMonth, "MMMM, yyyy")}</C4Text>
                    <SizedBox width={"8px"} />
                    <CustomIcon iconName={isOpen ? "chevron_up" : "chevron_down"} size={"16px"} cursor={"pointer"} />
                </Row>
            </BaseButton>
            {isOpen && (
                <CalendarWrapper
                    openedCalendarLeftSide={openedCalendarLeftSide}
                    $leftPositon={"-180px"}
                    $notLeftPositon={"0"}
                >
                    <CalendarComponent
                        type={type}
                        setType={setType}
                        onCaptionClick={handleCaptionClick}
                        onMonthSelect={handleMonthSelect}
                        selectedMonth={currentMonth}
                    />
                </CalendarWrapper>
            )}
        </MenuContainer>
    );
}

export default CustomMonthSelectButton;
